<template>
  <div style=" padding: 0 10px;">
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-success mt-1">
      <b-tab title="Келди-кетди" @click="getData" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date" />
            <b-button class="qoshishBtn" variant="primary" @click="getData">
              <span>
                {{ $t("Кўриш") }}
              </span>
            </b-button>
          </div>
          <div class="table-scrol">
            <table class="table table-sm table-striped">
              <tr class="bg-dark text-white">
                <th>№</th>
                <th>{{ "Ходим" }}</th>
                <th>{{ "Келиш вақти" }}</th>
                <th>{{ "Кетиш вақти" }}</th>
                <th>{{ "Келди - Кетди" }}</th>
                <!-- <th>{{ "Кетди" }}</th> -->
              </tr>
              <tr v-for="(item, index) in items" :key="index" @dblclick="Clicked(item)"
                :class="item.disabled ? 'bg-light' : ''">
                <td>{{ index + 1 }}</td>
                <td class="text-left">{{ item.user_name }}</td>
                <!-- Rejadagi vaqt -->
                <td><small class="text-muted">{{ item.plan_come }}</small></td>
                <td><small class="text-muted">{{ item.plan_leave }}</small></td>

                <!-- Keldi-Ketdi holati -->
                <td>
                  <template v-if="!item.disabled">
                    <b-badge :variant="item.is_late ? 'danger' : (item.real_come_time ? 'success' : 'warning')">
                      {{ item.real_come_time ? formatTimestamp(item.real_come_time) : 'Kelmagan' }}
                    </b-badge>
                    <b-badge class="ml-1"
                      :variant="item.left_early ? 'danger' : (item.real_leave_time ? 'success' : 'warning')">
                      {{ item.real_leave_time ? formatTimestamp(item.real_leave_time) : 'Ketmagan' }}
                    </b-badge>
                  </template>
                  <b-badge v-else variant="secondary">Dam olish kuni</b-badge>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-tab>
      <b-tab title="Давомат" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getDavomat">
              <span>
                {{ $t("Кўриш") }}
              </span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Izoh</th>
                <th v-for="item in days" style="width: 80px !important;">
                  <div class="card_month">
                    {{ item | dateFormatDay }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px;" v-for="(item, index) in davomat" :key="index">
                <td>{{ item.user_name }}</td>
                <td v-for="(day, index) in days">
                  <span style="font-size: 12px;" v-html="getDavomadForuser(day, days[index + 1] || day + 86400000, item)"></span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- <table border="1px solid black"  class="shablo_table">
                <thead style="text-align: center;">
                  <tr>
                    <th style="width: 200px;">Izoh</th>
                    <th v-for="item in days" style="width: 80px !important;">
                      <div class="card_month">
                        {{ item | dateFormatDay}} 
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="height: 30px;" v-for="(item, index) in davomat" :key="index">
                    <td>{{ item.user_name }}</td>
                  </tr>
                </tbody>
              </table> -->
        </div>
      </b-tab>
      <b-tab title="Жарималар" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getJarima">
              <span>
                {{ $t("Кўриш") }}
              </span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Izoh</th>
                <th v-for="item in days" style="width: 80px !important;">
                  <div class="card_month">
                    {{ item | dateFormatDay }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px;" v-for="(item, index) in jarima" :key="index">
                <td>{{ item.user_name }}</td>
                <td v-for="day in days" :key="day">
                  <div :class="getDayPenalty(day, item) > 0 ? 'penalty-active' : 'penalty-none'">
                    {{ getDayPenalty(day, item) > 0 ? getDayPenalty(day, item).toLocaleString() : '' }}
                  </div>
                </td>
              </tr>
              <!-- <tr v-for="child in item">
                    {{ child }}
                  </tr> -->
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab title="Ойлик ва жарималар" @click="getDavomat" title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;">
        <div class="tek-card">
          <div style="padding: 10px 0; display: flex;">
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date1" />
            <input style="width: 170px; margin-right: 10px;" class="form-control" type="date" v-model="date2" />
            <b-button class="qoshishBtn" variant="primary" @click="getOylik">
              <span>
                {{ $t("Кўриш") }}
              </span>
            </b-button>
          </div>
        </div>
        <div>
          <table border="1px solid black" class="shablo_table">
            <thead style="text-align: center;">
              <tr>
                <th style="width: 200px;">Исм</th>
                <th style="width: 300px;">
                  Жарима
                </th>
                <th style="width: 300px;">
                  Ойлик
                </th>
                <th style="width: 300px;">
                  Якуний
                </th>
                <th style="width: 300px;">
                  Жарима
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in oylik" :key="index">
                <td class="text-left pl-3">{{ user.user_name }}</td>
                <td class="text-danger font-weight-bold">{{ calculateTotalPenalty(user) }}</td>
                <td class="text-primary">{{ user.salary ? user.salary.toLocaleString() : 0 }}</td>
                <td class="bg-light-success font-weight-bold">
                  {{ (parseFloat(user.salary || 0) - calculateTotalPenaltyRaw(user)).toLocaleString() }}
                </td>
                <td>
                  <b-button size="sm" variant="outline-info" @click="showDetails(user)">
                    <b-icon icon="eye"></b-icon> Batafsil
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </b-tab>
    </b-tabs>
    <!-- Batafsil ma'lumot modali -->
    <b-modal id="details-modal" size="lg" :title="selectedItem ? selectedItem.user_name : ''" hide-footer>
      <div v-if="selectedItem" class="p-2">
        <div class="d-flex justify-content-between border-bottom pb-2 mb-3">
          <span><strong>Ish vaqti:</strong> {{ selectedItem.come_time }} - {{ selectedItem.leave_time }}</span>
          <span class="text-primary"><strong>Sana:</strong> {{ date }}</span>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-bordered table-sm">
            <thead class="thead-light text-center">
              <tr>
                <th>#</th>
                <th>Harakat</th>
                <th>Vaqt (HH:mm:ss)</th>
                <th>Jarima</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="face in selectedItem.user_faceid">
                <tr v-for="(child, cIdx) in face.user_faceid_child" :key="child.id">
                  <td class="text-center">{{ cIdx + 1 }}</td>
                  <td class="text-center">
                    <b-badge :variant="child.type === 'come' ? 'success' : 'danger'" style="width: 70px;">
                      {{ child.type === 'come' ? 'КЕЛДИ' : 'КЕТДИ' }}
                    </b-badge>
                  </td>
                  <td class="text-center font-weight-bold">
                    {{ formatTimestamp(child.datetime) }}
                  </td>
                  <td class="text-center" :class="child.price > 0 ? 'text-danger font-weight-bold' : 'text-muted'">
                    {{ child.price > 0 ? child.price.toLocaleString() : '0' }}
                  </td>
                  <td class="text-center">
                    <i v-if="child.type === 'come' && child.price > 0" class="small">Кечикиш</i>
                    <i v-else-if="child.type === 'leave' && child.price > 0" class="small">Вақтли кетиш</i>
                    <i v-else class="small">-</i>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot class="bg-light">
              <tr class="font-weight-bold">
                <td colspan="3" class="text-right">Kunlik umumiy jarima:</td>
                <td class="text-center text-danger">{{ calculateTotalPenalty(selectedItem) }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: "UserIndex",
  components: {},
  data() {
    return {
      items: [],
      davomat: [],
      oylik: [],
      jarima: [],
      jarimaList: [],
      date: new Date().toISOString().slice(0, 10),
      date1: new Date().toISOString().slice(0, 8) + "01",
      date2: new Date().toISOString().slice(0, 10),
      user_id: null,
      days: [],
      selectedItem: null, // Tanlangan foydalanuvchi uchun
    };
  },
  filters: {

    dateFormatDD: function (date) {
      if (date) {
        return moment.unix(date).utcOffset(300).format("DD.MM.YYYY HH:mm");
      } else {
        return "";
      }
    },
    dateFormatDay: function (date) {
      if (date) {
        return moment(new Date(date)).format("DD");
      } else {
        return "";
      }
    },

  },
  mounted() {
    this.getData(),
      this.getJarima(),
      this.getOylik()
  },
  methods: {
    // Dropdown(item) {
    //   let self = this;
    //   let datetime1 = 0;
    //   let datetime2 = 0;
    //   datetime1 = parseInt(
    //     new Date(self.date1)
    //       .valueOf()
    //       .toString()
    //       .slice(0, 10)
    //   );
    //   datetime2 =
    //     parseInt(
    //       new Date(self.date2)
    //         .valueOf()
    //         .toString()
    //         .slice(0, 10)
    //     ) + 86399;
    //   axios({
    //     method: "post",
    //     url: "/hisobot/jarimaAll",
    //     data: {
    //       date1: datetime1,
    //       date2: datetime2,
    //       parent_id: item.id
    //     }
    //   }).then(res => {
    //     this.jarimaList = res.data;
    //   });
    // },
    Clicked(item) {
      // Asl ma'lumotni o'zgartirmaslik uchun nusxa olamiz (Deep copy)
      let sortedItem = JSON.parse(JSON.stringify(item));

      if (sortedItem.user_faceid && sortedItem.user_faceid.length > 0) {
        sortedItem.user_faceid.forEach(face => {
          if (face.user_faceid_child && Array.isArray(face.user_faceid_child)) {
            // datetime bo'yicha kichigidan kattasiga (o'sish tartibida) saralash
            face.user_faceid_child.sort((a, b) => a.datetime - b.datetime);
          }
        });
      }

      this.selectedItem = sortedItem;
      this.$bvModal.show("details-modal");
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return "-";
      return moment.unix(timestamp).utcOffset(300).format("HH:mm:ss");
    },
    formatTime(seconds) {
      if (!seconds) return "-";
      return moment.unix(seconds).utcOffset(300).format("HH:mm");
    },

    dateFormatDays: function (date) {
      if (date) {
        return moment.unix(date).utcOffset(300).format("DD.MM.YYYY HH:mm");
      } else {
        return "";
      }
    },
    getWorkDuration(dayTimestamp, user) {
      const d1 = Math.floor(dayTimestamp / 1000);
      const d2 = d1 + 86399;

      // Shu kunga tegishli yozuvni topish
      const record = user.user_faceid.find(f => f.real_come_time >= d1 && f.real_come_time <= d2);

      if (!record || !record.real_come_time || !record.real_leave_time) return "-";

      let diff = record.real_leave_time - record.real_come_time;
      let hours = Math.floor(diff / 3600);
      let minutes = Math.floor((diff % 3600) / 60);
      return `${hours}:${minutes.toString().padStart(2, '0')}`;
    },
    getDayPenalty(dayTimestamp, user) {
      const d1 = Math.floor(dayTimestamp / 1000);
      const d2 = d1 + 86399;

      const record = user.user_faceid.find(f =>
        (f.real_come_time >= d1 && f.real_come_time <= d2) ||
        (f.real_leave_time >= d1 && f.real_leave_time <= d2)
      );

      if (!record || !record.user_faceid_child) return 0;

      const sum = record.user_faceid_child.reduce((total, child) => {
        return total + parseFloat(child.price || 0);
      }, 0);

      return sum;
    },
    calculateTotalPenaltyRaw(user) {
      if (!user || !user.user_faceid) return 0;

      let total = 0;
      user.user_faceid.forEach(face => {
        if (face.user_faceid_child && Array.isArray(face.user_faceid_child)) {
          face.user_faceid_child.forEach(child => {
            total += parseFloat(child.price || 0);
          });
        }
      });
      return total;
    },

    // UI (ekran) da chiroyli ko'rinishda (string) chiqarish uchun
    calculateTotalPenalty(item) {
      let total = 0;
      if (item.user_faceid) {
        item.user_faceid.forEach(face => {
          if (face.user_faceid_child) {
            face.user_faceid_child.forEach(child => {
              total += parseFloat(child.price || 0);
            });
          }
        });
      }
      return total.toLocaleString() + " so'm";
    },

    // Yakuniy oylikni hisoblash
    calculateFinalSalary(user) {
      const salary = parseFloat(user.salary || 0);
      const penalty = this.calculateTotalPenaltyRaw(user);
      const final = salary - penalty;
      return final.toLocaleString('ru-RU');
    },
    getData() {
      let self = this;
      self.davomat = []
      axios({
        method: "post",
        url: "/hisobot/user_faceid",
        data: {
          date: self.date
        }
      }).then(res => {
        if (res) {
          self.items = res.data.data;
        }
      });
    },
    getDaysBetween(date1, date2) {
      let startDate = new Date(date1.slice(0, 10)); // YYYY-MM-DD qismini olish
      let endDate = new Date(date2.slice(0, 10));
      let days = [];

      while (startDate <= endDate) {
        days.push(startDate.getTime()); // Faqat kun (DD) ni olish
        startDate.setDate(startDate.getDate() + 1);
      }

      return days;
    },
    getJarimaForuser(timestamp, timestamp2, face) {
      let self = this
      let d1 = Math.floor(timestamp / 1000)
      let d2 = Math.floor(timestamp2 / 1000)
      let arr = []
      for (let i = 0; i < face.length; i++) {
        const element = face[i].user_faceid_child.filter(i => i.datetime > d1 && i.datetime <= d2);
        arr = arr.concat(element)
      }
      // let arr = face.user_faceid_child.filter(i => i.datetime > d1 && i.datetime <= d2)
      const total = arr.reduce((total, item) => total += item.price || 0, 0);

      return total ? total.toLocaleString('ru-RU') : '';

    },

    getDavomadForuser(timestamp, timestamp2, item) {
      const d1 = Math.floor(timestamp / 1000);
      const d2 = Math.floor(timestamp2 / 1000);

      if (!item || !Array.isArray(item.user_faceid)) return '-';

      for (const record of item.user_faceid) {
        const come = record.real_come_time;
        const leave = record.real_leave_time;

        if (come && come >= d1 && come <= d2) {
          const comeFmt = moment.unix(come).utcOffset(300).format("HH:mm");
          const leaveFmt = leave ? moment.unix(leave).utcOffset(300).format("HH:mm") : '?';
          let times = `${comeFmt} / ${leaveFmt}`;

          const penalties = record.user_penalty_bonus || [];
          const penalty = penalties.find(p => p.type === 'penalty');
          const bonus = penalties.find(p => p.type === 'bonus');

          if (penalty) {
            const amt = Number(penalty.summa).toLocaleString('ru-RU');
            times += `<br><span style="color:#dc3545;font-size:11px;">-${amt}</span>`;
          } else if (bonus) {
            const amt = Number(bonus.summa).toLocaleString('ru-RU');
            times += `<br><span style="color:#28a745;font-size:11px;">+${amt}</span>`;
          }

          return times;
        }
      }

      return '-';
    },
    // getDavomadForuser(timestamp, timestamp2, face) {
    //   let d1 = Math.floor(timestamp / 1000);
    //   let d2 = Math.floor(timestamp2 / 1000);

    //   if (
    //     face &&
    //     face.real_come_time &&
    //     face.real_leave_time &&
    //     face.real_come_time >= d1 &&
    //     face.real_come_time <= d2
    //   ) {
    //     // Kelgan vaqti va ketgan vaqt orasidagi farq (sekundlarda)
    //     let totalSeconds = face.real_leave_time - face.real_come_time;

    //     // Sekundni soatga aylantiramiz
    //     let hours = totalSeconds / 3600;
    //     return hours.toFixed(2); // 2 raqamgacha aniqlik bilan (masalan: 5.58)
    //   }

    //   return '';
    // },
    getDavomat() {
      let self = this;
      self.item = []
      self.days = self.getDaysBetween(self.date1, self.date2)
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      }
      axios({
        method: "post",
        url: "/hisobot/davomat",
        data: datas
      }).then(res => {
        if (res) {
          self.davomat = res.data.data;
        }
      });
    },
    getJarima() {
      let self = this;
      self.item = []
      self.days = self.getDaysBetween(self.date1, self.date2)
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      }
      axios({
        method: "post",
        url: "/hisobot/jarima",
        data: datas
      }).then(res => {
        if (res) {
          self.jarima = res.data.data;
        }
      });
    },
    // getOylik() {
    //   let self = this;
    //   self.item = []
    //   self.days = self.getDaysBetween(self.date1, self.date2)
    //   let datas = {
    //     date1: self.date1,
    //     date2: self.date2,
    //     user_id: self.user_id
    //   }
    //   axios({
    //     method: "post",
    //     url: "/hisobot/oylik",
    //     data: datas
    //   }).then(res => {
    //     if (res) {
    //       self.oylik = res.data.data;
    //     }
    //   });
    // },
    getOylik() {
      let self = this;
      self.item = [];
      self.days = self.getDaysBetween(self.date1, self.date2);
      let datas = {
        date1: self.date1,
        date2: self.date2,
        user_id: self.user_id
      };

      axios({
        method: "post",
        url: "/hisobot/oylik",
        data: datas
      }).then(res => {
        if (res && res.data && Array.isArray(res.data.data)) {
          let result = res.data.data.map(user => {
            let jami_jarima = 0;

            // Har bir user_faceid ichidagi childlar bo‘yicha price yig‘amiz
            user.user_faceid.forEach(face => {
              if (Array.isArray(face.user_faceid_child)) {
                face.user_faceid_child.forEach(child => {
                  jami_jarima += child.price || 0;
                });
              }
            });

            // Yakuniy oylik = salary - jami_jarima
            let yakuniy_oylik = (user.salary || 0) - jami_jarima;

            // Natijalarni formatlab userga qo‘shamiz
            user.jami_jarima = jami_jarima.toLocaleString('ru-RU');
            user.yakuniy_oylik = yakuniy_oylik.toLocaleString('ru-RU');

            return user;
          });

          self.oylik = result;
        }
      });
    }


  },
};
</script>
<style scoped>
.tek-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  min-height: 0px;
  background: #fff;
  padding: 10px;
}

.red_class {
  background-color: #ff5858;
  color: #fff;
}

.table-scrol {
  width: 100%;
  height: calc(100vh - 235px);
  overflow: auto;
}

#table {
  width: 99% !important;
}

.table {
  margin: 0px 0px !important;
}

.text-right {
  text-align: right;
}

.font-weight-bold {
  font-weight: bold;
}

#details-modal .table th {
  background-color: #f8f9fa;
  color: #333;
}

label,
td,
th,
tr {
  /* font-family: Roboto; */
  font-weight: 500;
  /* text-transform: capitalize; */
  font-size: 13pt;
  height: 30px !important;
  text-align: center;
}

.reds {
  color: red;
}

th {
  color: #195fb0;
  background-color: #f4f7fb;
}

.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}

.qoshishBtn {
  display: flex;
  border-radius: 8px;
}

.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>